export const buildApiEnvironment = (base_url: string) => ({
  rootUrl: `${base_url}`,
  cash: {
    i18n: {
      root: `${base_url}/cash-i18n-api/dictionary`,
    },
    logout: {
      root: `${base_url}/nilo-user/users/actions/logout`,
    },
  },
  nilo: {
    authorization: {
      root: `${base_url}/nilo-authorization`,
    },
    base: {
      root: `${base_url}/nilo-base-api`,
      view: `${base_url}/nilo-base-view`,
      contactType: {
        view: `${base_url}/nilo-base-view/contact-types`,
      },
    },
    branch: {
      view: `${base_url}/nilo-geographies-view/branches`,
    },
    billing: {
      root: `${base_url}/nilo-billing/manual-billing-events`,
      view: `${base_url}/nilo-billing-view/manual-billing-events`,
      normalView: `${base_url}/nilo-billing-view`,
      fileLayout: `${base_url}/nilo-billing/file-types`,
      billingPeriod: `${base_url}/nilo-billing/billing-periods`,
      billingIncidence: `${base_url}/nilo-billing/billing-incidences`,
    },
    city: {
      view: `${base_url}/nilo-geographies-view/cities`,
    },
    contract: {
      root: `${base_url}/nilo-contract`,
      view: `${base_url}/nilo-contract-view/contracts`,
    },
    country: {
      view: `${base_url}/nilo-geographies-view/countries`,
    },
    streetType: {
      view: `${base_url}/nilo-geographies-view/street-types`,
    },
    contractLine: {
      view: `${base_url}/nilo-contract-view/contract-lines`,
    },
    contractStatus: {
      view: `${base_url}/nilo-contract-view/contract-status`,
    },
    currency: {
      view: `${base_url}/nilo-base-view/currencies`,
    },
    customer: {
      root: `${base_url}/nilo-customer`,
      view: `${base_url}/nilo-customer-view`,
      center: `${base_url}/nilo-customer/centers`,
      servicePoint: `${base_url}/nilo-customer/service-points`,
      entity: `${base_url}/nilo-customer/entities`,
      address: `${base_url}/nilo-customer-view/locations`,
    },
    formatTypes: {
      view: `${base_url}/nilo-base-view/format-types`,
    },
    integrationControl: {
      root: `${base_url}/nilo-integration-control`,
    },
    itemServiceAgreement: {
      view: `${base_url}/nilo-service-agreement-view/service-agreement-items`,
    },
    holiday: {
      root: `${base_url}/nilo-base-api`,
    },
    hourType: {
      view: `${base_url}/nilo-base-view/hour-types`,
    },
    language: {
      root: `${base_url}/nilo-base-api`,
    },
    product: {
      view: `${base_url}/nilo-contract-view/products`,
    },
    province: {
      view: `${base_url}/nilo-geographies-view/provinces`,
    },
    rate: {
      view: `${base_url}/nilo-contract-view/rates`,
    },
    serviceAgreement: {
      view: `${base_url}/nilo-service-agreement-view/service-agreements`,
      root: `${base_url}/nilo-service-agreement`,
    },
    //FIXME: this urls are looking kind of janky, but i didn't have time to fix and test
    user: {
      root: `${base_url}/nilo-user`,
      view: `${base_url}/nilo-user-view`,
    },
    zone: {
      view: `${base_url}/nilo-geographies-view/zones`,
    },
    geographies: {
      root: `${base_url}/nilo-geographies-api`,
      view: `${base_url}/nilo-geographies-view`,
    },
    address: {
      root: `${base_url}/nilo-address`,
      view: `${base_url}/nilo-address-view`,
    },
    center: {
      view: `${base_url}/nilo-customer-view/centers`,
    },
    entity: {
      view: `${base_url}/nilo-customer-view/entities`,
    },
    servicePoint: {
      view: `${base_url}/nilo-customer-view/service-points`,
    },
    importCenterLocation: {
      root: `${base_url}/nilo-customer-agent/api/address-agent/excel`,
    },
  },
});
